
/* ROYAL BOBBLES FREE SHIPPING PROGRESS */

(() => {
  const THRESHOLD = 6000; // $60.00 in cents

  const formatMoney = (cents) =>
    (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

  async function updateShippingProgress() {
    const container = document.getElementById('rb-shipping-progress');
    if (!container) return;

    const message = container.querySelector('.rb-shipping-message');
    const fill = container.querySelector('.rb-shipping-fill');
    const track = container.querySelector('.rb-shipping-track');

    if (!message || !fill || !track) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await response.json();
      const remaining = Math.max(0, THRESHOLD - cart.total_price);
      const progress = Math.min(
        100,
        (cart.total_price / THRESHOLD) * 100
      );

      message.textContent = remaining > 0
        ? `You're only ${formatMoney(remaining)} away from FREE Standard Shipping!`
        : "You've unlocked FREE Standard Shipping!";

      fill.style.width = progress + '%';

      track.setAttribute(
        'aria-valuenow',
        Math.min(60, cart.total_price / 100).toFixed(2)
      );

    } catch (error) {
      message.textContent =
        'Free Standard Shipping on orders of $60 or more.';
    }
  }

  function initialize() {
    const notification = document.querySelector('cart-notification');
    if (!notification) return;

    const observer = new MutationObserver(() => {
      if (notification.classList.contains('active')) {
        updateShippingProgress();
      }
    });

    observer.observe(notification, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (notification.classList.contains('active')) {
      updateShippingProgress();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
